/**
 * What a guest looks at while it is trying to get back in, before a game has started.
 *
 * A player who can see eleven seconds left will wait eleven seconds. A player watching a spinner
 * reloads the tab. The sentence itself is [rejoiningLine](../../net/lobby/lobbyNotices.ts), because
 * the same wait happens over a running game and one sentence written twice drifts.
 *
 * Cancel is always there. Choosing to stop waiting is a decision a player is allowed to make, and
 * without it the only way out of a fifteen second wait is closing the game.
 */

import { LOBBY_STOP_WAITING } from '@/text/lobbyText';
import { el, setText, setVisible } from '@/ui/dom';
import { rejoiningLine } from '@/net/lobby/lobbyNotices';

export interface LobbyReconnectPanel {
  readonly root: HTMLElement;
  /** Null means nothing is being waited for, and the panel goes away. */
  show(msLeft: number | null): void;
}

export function createLobbyReconnectPanel(onCancel: () => void): LobbyReconnectPanel {
  const root = el('div', 'lobby-reconnect');
  root.setAttribute('role', 'status');

  const line = el('p', 'lobby-reconnect-line', '');
  const cancel = el('button', 'lobby-quiet', LOBBY_STOP_WAITING);
  cancel.type = 'button';
  cancel.addEventListener('click', onCancel);

  root.append(line, cancel);
  setVisible(root, false);

  return {
    root,
    show(msLeft: number | null): void {
      setVisible(root, msLeft !== null);
      if (msLeft === null) return;
      setText(line, rejoiningLine(msLeft));
    },
  };
}
